import { API_ENDPOINTS, apiService } from "../api";
import type { ModelChangesApi, ModelRejectionApi, ModelRunAcceptedApi } from "./modelReview.types";
import type { ModelStatusApi } from "./modelStatus.types";

/** Where the tenant's data model stands. Rejects on HTTP errors. */
export const fetchModelStatus = (): Promise<ModelStatusApi> =>
  apiService.get<ModelStatusApi>(API_ENDPOINTS.modelling.status);

/** A held build's changes, for the tenant's admin. */
export const fetchModelChanges = (runId: string): Promise<ModelChangesApi> =>
  apiService.get<ModelChangesApi>(API_ENDPOINTS.modelling.changes(runId));

/** Approves a held build: Modelling builds and publishes it. */
export const approveModelChange = (runId: string): Promise<ModelRunAcceptedApi> =>
  apiService.post<ModelRunAcceptedApi>(API_ENDPOINTS.modelling.approve(runId), {});

/** Rejects a held build: the live model stays and the same change isn't raised again. */
export const rejectModelChange = (runId: string): Promise<ModelRejectionApi> =>
  apiService.post<ModelRejectionApi>(API_ENDPOINTS.modelling.reject(runId), {});
